export default __webpack_public_path__ + "static/hero-internet-6f06800244a8e84018f9f6a39201d874.jpg";